import React, { useEffect, useRef } from 'react';
import { Users, User, Users2, Building } from 'lucide-react';
import { TeamSize, QuestionnaireData } from '../../types';

interface TeamSizeStepProps {
  data: Partial<QuestionnaireData>;
  onChange: (data: Partial<QuestionnaireData>) => void;
}

const sizes = [
  {
    id: 'solo' as TeamSize,
    title: 'Just Me',
    description: 'Working independently',
    icon: User,
  },
  {
    id: 'small' as TeamSize,
    title: 'Small Group',
    description: '2-5 people',
    icon: Users,
  },
  {
    id: 'medium' as TeamSize,
    title: 'Medium Size',
    description: '6-20 people',
    icon: Users2,
  },
  {
    id: 'large' as TeamSize,
    title: 'Large Organization',
    description: '20+ people',
    icon: Building,
  },
];

export function TeamSizeStep({ data, onChange }: TeamSizeStepProps) {
  const descriptionRef = useRef<HTMLParagraphElement>(null);

  useEffect(() => {
    if (data.teamSize && descriptionRef.current) {
      setTimeout(() => {
        descriptionRef.current?.scrollIntoView({
          behavior: 'smooth',
          block: 'start'
        });
      }, 100);
    }
  }, [data.teamSize]);

  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 sm:gap-4">
      {sizes.map((size) => {
        const Icon = size.icon;
        return (
          <button
            key={size.id}
            onClick={() => onChange({ teamSize: size.id })}
            className={`p-4 sm:p-6 rounded-xl border-2 transition-all text-left ${
              data.teamSize === size.id
                ? 'border-blue-600 bg-blue-50'
                : 'border-gray-200 hover:border-blue-200 hover:bg-gray-50'
            }`}
          >
            <Icon className={`w-6 h-6 sm:w-8 sm:h-8 mb-3 sm:mb-4 ${
              data.teamSize === size.id ? 'text-blue-600' : 'text-gray-600'
            }`} />
            <h3 className="text-base sm:text-lg font-semibold mb-1 sm:mb-2">{size.title}</h3>
            <p ref={descriptionRef} className="text-sm sm:text-base text-gray-600">{size.description}</p>
          </button>
        );
      })}
    </div>
  );
}

export default TeamSizeStep;